<template>
  <div class="order rightMenu-box-wrapper">
    <div class="content border" style="min-height: 1900px;" v-if="total">
      <div class="rightMenu-box">
        <div class="rightMenu-container">
          <div class="rightMenu-order">
            <div class="order-title">
              Данные по заказу
            </div>
            <a href="/customer/basket" class="hoverLineMoved rightMenu-order-link">
              Изменить заказ
            </a>
            <div class="rightMenu-order-item">
              <div class="rightMenu-order-item-title">
                Товары
              </div>
              <div class="rightMenu-order-item-inf">
                {{ totalCount }} {{ totalCount | wordEndings('товар', 'товара', 'товаров') }}
              </div>
              <div class="rightMenu-order-item-value">
                {{ total | priceFormat(true, false) }} ₽
              </div>
            </div>
            <div class="rightMenu-order-item" v-if="selectedDelivery">
              <div class="rightMenu-order-item-title">
                Доставка
              </div>
              <div class="rightMenu-order-item-inf">
                {{ selectedDelivery.name }}
              </div>

              <div class="rightMenu-order-item-value" v-if="selectedDelivery&&selectedDelivery.cost">
                <span v-if="selectedDelivery.cost.amount">{{ selectedDelivery.cost.amount | priceFormat(true, false) }} ₽</span>
                <span v-else>бесплатно</span>
                <br/> {{ selectedDelivery.duration }}
              </div>
            </div>
            <div class="rightMenu-order-item" v-if="selectedPaymentType">
              <div class="rightMenu-order-item-title">
                Оплата
              </div>
              <div class="rightMenu-order-item-inf">
                {{ selectedPaymentType.name }}
              </div>
            </div>
            <div class="rightMenu-order-result">
              <div class="rightMenu-order-result-text">Итого</div>
              <div class="rightMenu-order-result-value">{{ totalWithDelivery  | priceFormat(true, false) }} ₽</div>
            </div>
            <div class=" def-form-checkbox">
              <div class="radio-custom" @click="agreeWithPrivacy=true" :class="{'active' : agreeWithPrivacy}"></div>
              <label style="line-height: 1.5" :class="errorFields.includes('total') && 'is-invalid'">
                Согласие на обработку персональных данных в соответствии с
                <a href="/privacy-policy"> политикой конфиденциальности </a>
              </label>
            </div>
            <br />
            <div v-if="!startCreateOrder">
              <a href="javascript:void(0)" class="btn-orange rightMenu-order-btn" @click="createOrder"
              >Оформить заказ</a
              >
            </div>
            <div class="bootstrap" v-else>
              <div class="text-center m-4">
                <b>оформляем заказ...</b>
              </div>
            </div>


          </div>
        </div>
        <div class="order-box nbt-container">
          <div class="order-title">
            Контактные данные
          </div>
          <!--
          <div class="nbt-menu order-type">
              <a href="" class="order-link hoverLineMoved">
                  Физическое лицо
              </a>
              <a href="" class="order-link hoverLineMoved">
                  Юридическое лицо
              </a>
          </div>
          -->
          <div class="nbt-tabs">
            <div class="nbt-tab active">
              <div class="order-row">
                <div class="def-form-box">
                  <input
                      class="def-form-input"
                      :class="errorFields.includes('last_name') && 'is-invalid'"
                      type="text"
                      name="name"
                      @change="saveCustomerParams"
                      v-model="customerParams.lastName"
                      placeholder="Фамилия"
                  />
                </div>
                <div class="def-form-box">
                  <input
                      class="def-form-input"
                      :class="errorFields.includes('first_name') && 'is-invalid'"
                      type="text"
                      name="name"
                      @change="saveCustomerParams"
                      v-model="customerParams.firstName"
                      placeholder="Имя"
                  />
                </div>
              </div>
              <div class="order-row">
                <div class="def-form-box">
                  <input
                      class="def-form-input"
                      :class="errorFields.includes('phone') && 'is-invalid'"
                      type="text"
                      name="phone"
                      @change="saveCustomerParams"
                      v-model="customerParams.phone"

                      placeholder="Номер телефона"
                  />
                </div>
                <div class="def-form-box">
                  <input
                      class="def-form-input"
                      :class="errorFields.includes('email') && 'is-invalid'"
                      type="text"
                      name="mail"
                      @change="saveCustomerParams"
                      v-model="customerParams.email"

                      placeholder="Почта"
                  />
                </div>
              </div>

              <div class="order-title"  :class="errorFields.includes('delivery') && 'is-invalid'">
                Способ доставки
              </div>
              <div v-for="delivery in filteredDeliveries" :key="'d' + delivery.id">
                <div class=" def-form-checkbox order-check">

                  <div class="radio-custom" @click="selectedDelivery=delivery;selectedPaymentType=null"
                       :class="{'active' : selectedDelivery && delivery.id == selectedDelivery.id}"></div>
                  <label @click="selectedDelivery=delivery;selectedPaymentType=null">
                    {{ delivery.name }}
                    <span class="sub" v-html="delivery.description"></span>
                  </label>
                  <div v-if="selectedDelivery && delivery.id == 1 && delivery.id == selectedDelivery.id"
                       class="bootstrap">
                    <select v-model="selectedPridePvz" class="form-control">
                      <option :value="null" class="text-muted">выберите пункт самовывоза</option>
                      <option :value="pv" v-for="pv in pvz" :key="pv"> {{ pv }}</option>
                    </select>
                  </div>
                  <div v-if="selectedDelivery && (delivery.id == 2 || delivery.id == 3) && delivery.id == selectedDelivery.id" class="bootstrap">

                    <div class="btn-group selected-delivery">
                      <button :class="'btn  ' + (currentDeliveryService === sys.id ? ' btn-selected ' : '')" @click="currentDeliveryService = sys.id" v-for="sys in deliveriesServices" :key="sys.id"> {{ sys.name }}</button>
                    </div>
                  </div>

                </div>
                <!--<div class="order-label-value" >
                  {{ delivery.cost }}
                </div> -->
              </div>
              <a name="contacts"></a>

              <div class="order-title" v-if="selectedDelivery && [2,3,4].indexOf(selectedDelivery.id) > -1">
                Контактные данные
              </div>

              <div class="def-form-box bootstrap"
                   v-if="selectedDelivery && [2,3,4,5].indexOf(selectedDelivery.id) > -1">
                <select-address :service-id="currentDeliveryService" @select-address="setAddress"
                                :show-post-index="showPostIndex" ref="selectAddress"></select-address>
                <div class="row" v-if="showAddressField">
                  <div class="col">
                    <input type="text" class="form-control" v-model="customerParams.address.street"
                           placeholder="улица..."/>
                  </div>
                </div>
                <div class="row" v-if="showAddressField">
                  <div class="col">
                    <input type="text" v-model="customerParams.address.build" class="form-control"
                           placeholder="дом..."/>
                  </div>
                  <div class="col">
                    <input type="text" class="form-control" v-model="customerParams.address.constr"
                           placeholder="корпус..."/>
                  </div>
                  <div class="col">
                    <input type="text" class="form-control" v-model="customerParams.address.flat"
                           placeholder="квартира/офис..."/>
                  </div>
                </div>

                <div v-if="selectedDelivery&&(selectedDelivery.id==3&&pvzList.length&&!selectedPvzPoint)"
                     class="search-container">
                  <div class="row">
                    <div class="col">
                      Найдено: <b>{{ pvzList.length }}</b>
                    </div>
                    <div class="col text-right">
                      <ul class="list-inline">
                        <li class="list-inline-item"><a href="javascript: void(0);"
                                                        :class="{'active' : pvzListMode=='map'}"
                                                        @click="pvzListMode='map'">на карте</a></li>
                        <li class="list-inline-item"><a href="javascript: void(0);"
                                                        :class="{'active' : pvzListMode=='list'}"
                                                        @click="pvzListMode='list'">списком</a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="search-result" style="position: relative; top: 0px;" v-show="pvzListMode=='list'">
                    <input type="text" class="form-control" v-model="pvzName" placeholder="введите адрес ПВЗ..."/>
                    <ul style="margin-top: -30px;">
                      <li v-for="point in filteredPvzList" :key="point.id">
                        <a href="javascript:void(0)" @click="selectPvz(point)"><b>{{ point.address }}</b></a>
                      </li>
                    </ul>
                  </div>
                  <pvz-map @select-pvz="selectPvz" v-show="pvzListMode=='map'" :list="pvzList"
                           :simple-mode="false"></pvz-map>
                </div>


                <div v-if="selectedPvzPoint" class="selected-pvz">
                  <b>Пункт самовывоза:</b> <br/>
                  {{ selectedPvzPoint.address }} <a href="javascript:void(0)" @click="selectedPvzPoint=null">
                  изменить</a>
                  <div class="text-muted">
                    <small>
                      <b>Телефон:</b> {{ selectedPvzPoint.phone }} <br/>
                      <b>E-mail:</b> {{ selectedPvzPoint.email }} <br/>
                      <b>Время работы:</b> {{ selectedPvzPoint.work_time }}<br/>
                      {{ selectedPvzPoint.comment }}
                    </small>
                  </div>
                </div>
              </div>


              <div class="order-title" :class="errorFields.includes('payment') && 'is-invalid'">
                Способ оплаты
              </div>
              <div class="def-form-checkbox order-check" v-for="payment in filteredPayments" :key="'p' + payment.id">

                <div class="radio-custom" @click="selectedPaymentType=payment"
                     :class="{'active' : selectedPaymentType && payment.id == selectedPaymentType.id}"></div>
                <label @click="selectedPaymentType=payment">
                  {{ payment.name }}
                  <span class="sub" v-html="payment.description"></span>
                </label>
              </div>

              <textarea
                  class="def-form-textarea"
                  name="question"
                  id=""
                  cols="5"
                  v-model="comment"
                  placeholder="Комментарий к заказу"
              ></textarea>
            </div>
          </div>

        </div>
        <div class="rightMenu-order rightMenu-order-small">
          <div class="order-title">
            Данные по заказу
          </div>
          <a href="/customer/basket" class="hoverLineMoved rightMenu-order-link">
            Изменить заказ
          </a>
          <div class="rightMenu-order-item">
            <div class="rightMenu-order-item-title">
              Товары
            </div>
            <div class="rightMenu-order-item-inf">
              {{ totalCount }} {{ totalCount | wordEndings('товар', 'товара', 'товаров') }}
            </div>
            <div class="rightMenu-order-item-value">
              {{ total | priceFormat(true, false) }} ₽
            </div>
          </div>
          <div class="rightMenu-order-item" v-if="selectedDelivery">
            <div class="rightMenu-order-item-title">
              Доставка
            </div>
            <div class="rightMenu-order-item-inf">
              {{ selectedDelivery.name }}
            </div>
            <div class="rightMenu-order-item-value" v-if="selectedDelivery&&selectedDelivery.cost">
              <span v-if="selectedDelivery.cost.amount">{{
                  selectedDelivery.cost.amount | priceFormat(true, false)
                }} ₽ </span>
              <span v-else>бесплатно</span>
              <br/> {{ selectedDelivery.duration }}
            </div>
          </div>
          <div class="rightMenu-order-item" v-if="selectedPaymentType">
            <div class="rightMenu-order-item-title">
              Оплата
            </div>
            <div class="rightMenu-order-item-inf">
              {{ selectedPaymentType.name }}
            </div>
          </div>
          <div class="rightMenu-order-result">
            <div class="rightMenu-order-result-text">Итого</div>
            <div class="rightMenu-order-result-value">{{ totalWithDelivery  | priceFormat(true, false) }} ₽</div>
          </div>
          <div class=" def-form-checkbox" >
            <div class="radio-custom" @click="agreeWithPrivacy=true" :class="{'active' : agreeWithPrivacy}"></div>
            <label style="line-height: 1.5" :class="errorFields.includes('total') && 'is-invalid'">
              Согласие на обработку персональных данных в соответствии с
              <a href="/privacy-policy"> политикой конфиденциальности </a>
            </label>
          </div>
          <br />
          <a href="javascript:void(0)" class="btn-orange rightMenu-order-btn" @click="createOrder"
          >Оформить заказ</a
          >
        </div>
      </div>
    </div>
    <div class="content border bootstrap text-center" style="padding: 100px 0" v-else>
      <h4>Корзина не содержит товаров</h4>
      <a href="/catalog/top">Вернуться в общий каталог</a>
    </div>

  </div>
</template>

<script>
import {validateEmail, validatePhone} from "@/utils";

import SelectAddress from "./SelectAddress";
import PvzMap from "./PvzMap";
import {
  DELIVERY_SERVICE_SDEK,
  DELIVERY_SERVICE_BOXBERRY,
  DELIVERY_SERVICE_RUSSIAN_POST,

  DELIVERY_TYPE_SELF_ID,
  DELIVERY_TYPE_COURIER_ID,
  DELIVERY_TYPE_PVZ_ID,
  DELIVERY_TYPE_RUSSIAN_POST_ID,
  DELIVERY_TYPE_TTK_ID,

  PAYMENT_TYPE_CASH_ID
} from "../constant"

export default {
  name: 'Checkout',
  components: {PvzMap, SelectAddress},
  props: [
    'payments',
    'deliveries',
    'pvz',
    'maxTotalWeight',
    'maxPositionWeight'
  ],
  data() {
    return {
      regionId: null,
      cityId: null,
      postCode: null,

      errorFields: [],

      isDeliverySuccess: false,

      deliveriesServices: [
        {id: DELIVERY_SERVICE_SDEK, name: 'СДЭК'},
        {id: DELIVERY_SERVICE_BOXBERRY, name: 'Boxberry'},
//        {id: DELIVERY_SERVICE_RUSSIAN_POST, name: 'Почта России'},
      ],
      currentDeliveryService: DELIVERY_SERVICE_BOXBERRY,

      startCreateOrder: false,
      agreeWithPrivacy: false,
      deliverySum: 0,
      pvzList: [],
      pvzListMode: 'map',
      selectedPvzPoint: null,
      selectedPoint: null,
      pvzName: null,
      selectedPridePvz: null,
      firstName: null,
      lastName: null,

      customerParams: {
        fio: null,
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
        address: {
          build: null,
          street: null,
          flat: null,
          constr: null
        },
        city: null
      },
      comment: null,
      selectedDelivery: null,
      selectedPaymentType: null
    }
  },
  watch: {
    selectedDelivery() {
      if(this.currentDeliveryService && this.currentDeliveryService == DELIVERY_SERVICE_RUSSIAN_POST){
        this.getDeliveryCost(this.selectedDelivery.id == DELIVERY_TYPE_COURIER_ID ? 'courier' : 'pvz' );
      }else if (this.cityId && !this.selectedDelivery.cost) {
        if (this.selectedDelivery.id == DELIVERY_TYPE_COURIER_ID) {
          this.getDeliveryCost('courier');
        }
        if (this.selectedDelivery.id == DELIVERY_TYPE_PVZ_ID) {
          this.getPvzList();
        }
      }
    },
    currentDeliveryService() {
      this.selectedPvzPoint = null
      this.selectedPoint = null
      this.regionId = null
      this.cityId = null
      this.postCode = null
      this.$refs.selectAddress.clear()

      this.selectedDelivery.cost = null
      this.selectedDelivery.object = null
      this.selectedDelivery.duration = null
    },
    selectedPaymentType() {
      if([DELIVERY_TYPE_COURIER_ID, DELIVERY_TYPE_PVZ_ID].indexOf(this.selectedDelivery.id) > -1){
        this.getDeliveryCost(this.selectedDelivery.id == DELIVERY_TYPE_COURIER_ID ? 'courier' : 'pvz')
      }
      this.$log('Selected Delivery: -> ', this.selectedDelivery)
    },


  },
  computed: {
    total() {
      return this.$store.getters.basketTotal
    },
    totalCount() {
      return this.$store.getters.basketTotalCount
    },
    totalWithDelivery() {
      let summ = this.$store.getters.basketTotal;
      if (this.selectedDelivery && this.selectedDelivery.cost && this.selectedDelivery.cost.amount) {
        summ += parseInt(this.selectedDelivery.cost.amount);
      }
      return summ;
    },
    filteredPvzList() {
      if (!this.pvzName) {
        return this.pvzList
      }
      return this.pvzList.filter(point => point.address.toLowerCase().indexOf(this.pvzName.toLowerCase()) > -1)
    },
    filteredDeliveries() {
      // this.$log( 'Weight: -> ', this.maxTotalWeight, this.$store.getters.basketTotalWeight, this.maxPositionWeight, this.$store.getters.basketMaxPositionWeight )
      if (this.maxTotalWeight < this.$store.getters.basketTotalWeight || this.maxPositionWeight < this.$store.getters.basketMaxPositionWeight) {
        return this.deliveries.filter(delivery => [DELIVERY_TYPE_COURIER_ID, DELIVERY_TYPE_PVZ_ID].indexOf(delivery.id) == -1)
      }

      return this.deliveries
    },
    filteredPayments() {
      if (this.selectedDelivery && this.selectedDelivery.id == DELIVERY_TYPE_TTK_ID) {
        return this.payments.filter(payment => payment.id != PAYMENT_TYPE_CASH_ID)
      }
      return this.payments
    },
    showPostIndex() {
      return [DELIVERY_TYPE_COURIER_ID, DELIVERY_TYPE_RUSSIAN_POST_ID].indexOf(this.selectedDelivery.id) > -1 ||
          (this.selectedDelivery.id == DELIVERY_TYPE_PVZ_ID && this.currentDeliveryService == DELIVERY_SERVICE_RUSSIAN_POST)
    },
    showAddressField() {
      return [DELIVERY_TYPE_COURIER_ID, DELIVERY_TYPE_RUSSIAN_POST_ID].indexOf(this.selectedDelivery.id) > -1 ||
          (this.selectedDelivery.id == DELIVERY_TYPE_PVZ_ID && this.currentDeliveryService == DELIVERY_SERVICE_RUSSIAN_POST)
    }
  },
  mounted() {
    this.customerParams.firstName = this.$store.state.customerParams.firstName
    this.customerParams.lastName = this.$store.state.customerParams.lastName
    this.customerParams.phone = this.$store.state.customerParams.phone
    this.customerParams.email = this.$store.state.customerParams.email
  },
  methods: {
    createOrder() {
      if (this.startCreateOrder) {
        return
      }

      this.errorFields = []

      let error = [];
      this.$log('PVZ', this.customerParams?.address?.street, this.selectedPridePvz, this.selectedPvzPoint);
      if (!this.customerParams?.lastName) {
        error.push('Не указана фамилия');
        this.errorFields.push('last_name')
      }
      if (!this.customerParams?.firstName) {
        error.push('Не указано имя');
        this.errorFields.push('first_name')
      }
      if (!this.customerParams?.phone) {
        error.push('Не указан телефон');
        this.errorFields.push('phone')
      }
      if (!this.customerParams?.email) {
        error.push('Не указан email');
        this.errorFields.push('email')
      }

      if(this.customerParams?.email && !validateEmail(this.customerParams.email)) {
        error.push('Email заполнен неверно. ');
        this.errorFields.push('email')
      }
      if(this.customerParams?.phone && !validatePhone(this.customerParams.phone)) {
        error.push('Телефон заполнен неверно. ');
        this.errorFields.push('phone')
      }

      if (
          ( [DELIVERY_TYPE_COURIER_ID, DELIVERY_TYPE_PVZ_ID, DELIVERY_TYPE_RUSSIAN_POST_ID].indexOf(this.selectedDelivery?.id) > -1 ) &&
          !this.customerParams?.address?.street &&
          !this.selectedPridePvz &&
          !this.selectedPvzPoint
      ) {
        error.push('Не указан или не выбран адрес');
        this.errorFields.push('delivery')

      }
      // if(!this.customerParams.city) error.push('Не указан город');
      if (!this.selectedPaymentType) {
        error.push('Не указан Тип оплаты')
        this.errorFields.push('payment')
      }
      if (!this.selectedDelivery) {
        error.push('Не указан Тип доставки')
        this.errorFields.push('delivery')
      }
      if (!this.agreeWithPrivacy) {
        error.push('Необходимо указать что Вы согласны с правилами оформления заказа')
        this.errorFields.push('total')
      }

      if (
          this.selectedDelivery &&
          !this.selectedPoint &&
          ( [DELIVERY_TYPE_COURIER_ID, DELIVERY_TYPE_PVZ_ID, DELIVERY_TYPE_RUSSIAN_POST_ID].indexOf(this.selectedDelivery?.id) > -1 )
      ) {
        error.push('Не указан город/почтовый индекс доставки')
        this.errorFields.push('delivery')
      }

      if (
          this.selectedDelivery &&
          !this.selectedPoint &&
          (this.selectedDelivery?.id == 5)
      ) {
        error.push('Не указан город доставки')
        this.errorFields.push('delivery')
      }
      if (
          (this.selectedDelivery?.id == DELIVERY_TYPE_COURIER_ID || (this.selectedDelivery?.id == DELIVERY_TYPE_PVZ_ID && this.currentDeliveryService == DELIVERY_SERVICE_RUSSIAN_POST)) && !this.postCode
      ) {
        error.push('Не указан почтовый индекс доставки')
        this.errorFields.push('delivery')
      }
      // if (
      //     this.selectedDelivery &&
      //     (this.selectedDelivery.id == DELIVERY_TYPE_PVZ_ID && this.currentDeliveryService == DELIVERY_SERVICE_RUSSIAN_POST) &&
      //     !this.selectedPvzPoint
      // ) {
      //   error.push('Не указан ПВЗ')
      // }

      if (
          this.selectedDelivery &&
          this.selectedDelivery?.id == DELIVERY_TYPE_SELF_ID &&
          !this.selectedPridePvz
      ) {
        error.push('Не указан пункт самовывоза')
        this.errorFields.push('delivery')
      }

      if(
          [DELIVERY_TYPE_COURIER_ID, DELIVERY_TYPE_PVZ_ID].indexOf(this.selectedDelivery?.id) > -1 &&
          [DELIVERY_SERVICE_SDEK, DELIVERY_SERVICE_BOXBERRY].indexOf(this.currentDeliveryService) > -1 &&
          !this.isDeliverySuccess ){
        error.push('Доставка по укказанному адресу невозможна')
        this.errorFields.push('delivery')
      }



      if (error.length > 0) {
        this.$modal.show('dialog', {
          title: 'Ошибка в заказе',
          text: '<ul class="order-errors-list"><li>' + error.join('</li><li>') + '</li></ul>',
          buttons: [
            {
              title: 'Закрыть'
            }
          ]
        })
        return
      }
      if (this.selectedPoint && this.selectedPoint?.point) {
        this.selectedPoint.point.postCodeArray = [];
      }
      this.selectedDelivery.description = null;

      this.customerParams.fio = this.customerParams?.lastName + ' ' + this.customerParams?.firstName;

      const orderParam = {
        customer: this.customerParams,
        pvz: this.selectedPvzPoint || (this.selectedPridePvz ? {address: this.selectedPridePvz} : null),
        geopoint: this.selectedPoint,
        comment: this.comment,
        delivery: this.selectedDelivery,
        payment: this.selectedPaymentType,
        promocode: this.$store.state.promocode,
        positions: this.$store.state.basket.map((item) => {
          return {
            id: item.id,
            count: item.count,
            price_after_discount: item.price_after_discount || null,
            price_after_discount_key: item.price_after_discount_key || null,
            promocode_type_id: item.promocode_type_id || null
          }
        })
      };

      this.startCreateOrder = true;

      this.$http.post('/customer/create-order', orderParam).then(response => {
        const order = response.data.order
        const secret = response.data.secret
        this.$store.commit('clearBasket')
        this.$store.commit('removePromocode')
        window.location.href = '/customer/thank-you-page/?id=' + order.id + '&secret=' + secret;
      }, email => {
        this.startCreateOrder = false;
        this.$modal.show('dialog', {
          title: 'Ошибка в заказе',
          text: email.message,
          buttons: [
            {
              title: 'Закрыть'
            }
          ]
        })
      })
      window.ym(39587615, 'reachGoal', 'click.basket')
    },
    saveCustomerParams() {
      this.$store.commit('setCustomerParams', this.customerParams)
    },
    setAddress(data) {

      this.pvzList = []
      this.selectedPvzPoint = null
      this.selectedPoint = data
      if (data.point) {
        this.regionId = data.point.regionId || data.point.region_id;
        this.cityId = data.point.id;
      }

      if(data.post_code){
        this.postCode = data.post_code
      }

      if (this.selectedDelivery.id == DELIVERY_TYPE_PVZ_ID) {
        if (this.currentDeliveryService == DELIVERY_SERVICE_RUSSIAN_POST) {
          if (data.post_code) {
            this.getDeliveryCost('pvz')
          }
        } else {
          this.getPvzList()
        }
      } else {
        switch (this.selectedDelivery.id) {
          case DELIVERY_TYPE_COURIER_ID:
            if (data.post_code) {
              this.getDeliveryCost('courier')
            }
            return;
        }
      }
    },
    getDeliveryCost(deliveryType) {
      if(deliveryType == 'courier' && [DELIVERY_SERVICE_SDEK, DELIVERY_SERVICE_BOXBERRY].indexOf(this.currentDeliveryService) > -1 && !this.cityId ){
        return;
      }

      const deliveryParams = {
        company: this.currentDeliveryService,
        city_id: this.cityId,
        delivery_type: deliveryType,
        region_id: this.regionId,
        sclad_id: this.selectedPvzPoint ? this.selectedPvzPoint.uid : null,
        reciever_city_post_code: this.postCode,
        positions: this.$store.state.basket.map((item) => {
          return {
            id: item.id,
            count: item.count,
            price_after_discount: item.price_after_discount || null,
            price_after_discount_key: item.price_after_discount_key || null
          }
        }),
        payment_type: this.selectedPaymentType
      };

      // this.$log('Delivery Params -> ', deliveryParams);

      this.isDeliverySuccess = false
      this.$http.post('/delivery-service/cost', deliveryParams).then(response => {
        // this.$log('Delivery result -> ', response.data)
        if (response.data[0]) {
          this.selectedDelivery.cost = response.data[0].cost
          this.selectedDelivery.object = response.data[0]
          this.selectedDelivery.duration = response.data[0].period_from;
          if (response.data[0].period_to > response.data[0].period_from) {
            this.selectedDelivery.duration += '-' + response.data[0].period_to
          }
          this.selectedDelivery.duration += ' дн.';
          this.isDeliverySuccess = true
        }
      })


    },
    getPvzList() {
      if (!this.cityId) return;
      this.$http.post('/delivery-service/pvz-list/' + this.currentDeliveryService, {city_id: this.cityId}).then(response => {
        this.pvzList = response.data
        // this.$log('City result -> ', response.data)
      })
    },
    selectPvz(point) {
      this.$log('Select point: -> ', point);
      this.selectedPvzPoint = point;

      this.regionId = point.region_id;
      this.cityId = point.city_id;
      this.postCode = point.post_code;

      this.getDeliveryCost('pvz')
    }

  }
}
</script>

<style lang="scss" scoped>

.is-invalid {
  border-bottom: 3px solid red!important;
  background: #fff5f5 !important;
}

.selected-delivery {

  button {
    color: white;
    background: grey;

    &.btn-selected {
      background: var(--brandColor);
    }
  }
}

span.sub {
  font-size: 80%;
  margin-left: 20px;

  ul {
    margin-left: 0px;
    padding-left: 0px;
  }
}

.search-result {
  z-index: 1000;
  background: white;
  width: 100%;

  ul {
    li {
      a {
        color: black;
      }
    }
  }
}

.selected-pvz {
  line-height: 1.4;
  margin-top: 10px;
}

.list-inline {
  a.active {
    color: black;
  }
}

</style>